import { render, staticRenderFns } from "./SlsPD.vue?vue&type=template&id=471a039a"
import script from "./SlsPD.vue?vue&type=script&lang=js"
export * from "./SlsPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports